import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class TaxReportUseCase extends BaseUseCase {
    constructor(taxReportRepo) {
        super();
        this.taxReportRepo = taxReportRepo;
    }
    async fetchResult(requestData) {
        const taxReportData = await this.taxReportRepo.getTaxReportData(requestData);
        return taxReportData;
    }
}
export default TaxReportUseCase;
